import { isCollapsed } from '@udecode/plate-core';
import { isBlockEmpty, getElement } from '../../editorTools/queries';
import { copyBlocks, deleteBlock, duplicateBlock } from '../../editorTools/transforms';
import {
  isCopyHotKey, isDeleteHotKey, isDuplicateHotKey, isSaveHotkey,
} from '../../hotkeys';
import { createTPluginFactory } from '../../plate';
import { KEY_SHORTCUTS } from '../../pluginKeys';

export const createShortcutsPlugin = createTPluginFactory({
  key: KEY_SHORTCUTS,
  handlers: {
    onKeyDown: (editor) => (event) => {
      if (
        isCopyHotKey(event)
        && (!editor.selection || isCollapsed(editor.selection))
      ) {
        event.preventDefault();
        copyBlocks(editor);
        return true;
      }

      if (isDuplicateHotKey(event)) {
        event.preventDefault();
        duplicateBlock(editor);
        return true;
      }

      if (isSaveHotkey(event)) {
        event.preventDefault();
        editor.onSave(editor.children);
        return true;
      }

      if (isDeleteHotKey(event)) {
        if (isBlockEmpty(editor, getElement(editor))) {
          event.preventDefault();
          deleteBlock(editor);

          return true;
        }
        return false;
      }

      return undefined;
    },
  },
});
